export const KIT_VERSION = "f2581d3e";
